import { Text, Page, Image, View, StyleSheet } from '@react-pdf/renderer';
import strings from '@/language/Swedish';
import Header from '@/components/pdf/components/Header';
import Footer from '@/components/pdf/components/footer';
import { UserCustomerType } from '@/types/apiTypes';

interface StartPageProps {
  projectName: string | null;
  username: string;
  data: any;
  hideClientData?: boolean;
  project: any;
  priceImg: any;
  customer: UserCustomerType;
}

const PriceDevelopmentPage = ({
  projectName,
  data,
  username,
  hideClientData,
  project,
  priceImg,
  customer
}: StartPageProps) => {
  const styles = StyleSheet.create({
    wrapper: {
      padding: '6mm',
      paddingTop: 0,
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      marginTop: '3mm',
      gap: '6mm',
    },
  });

  return (
    <Page size="A4" orientation="landscape">
      <Header title={projectName} bgColor={customer?.primary_color} logo={customer?.logo_url} />
      <View style={styles.wrapper}>
        <View style={{ width: '100%' }}>
          <View style={{ marginBottom: 20 }}>
            <Text style={{ fontWeight: 500, fontFamily: 'Chivo' }}>
              {strings.priceDevelopment.pageHeading} {data.short_name}
            </Text>

            <Text
              style={{ fontWeight: 400, fontFamily: 'Chivo', fontSize: 14 }}>
              {project.indexValues.reference_type}
            </Text>
          </View>

          <View style={{ width: '100%' }}>
            {priceImg && <Image src={priceImg} />}
          </View>
        </View>
      </View>
      <Footer hideClientData={hideClientData} username={username} />
    </Page>
  );
};

export default PriceDevelopmentPage;
